export const STRIPE_PUBLIC_KEY =
  "pk_live_51Qxs0WLgMJN3EjvzNGxYDluQMOQ1j3s0cKOjlLvS9GbML5PcC6a8KHFwcbTw36XZGgjAwNjK3qJeyyeWNjkC9hlZ00jTfujsYD";

export const TRIAL_DAYS = 7;

export const API_URL = "https://color-backend-s7hn.onrender.com";

export const STRIPE_PRICE_ID = "price_1R2ETyLgMJN3Ejvzr5NbUDMZ";

export const REDIRECT_LINK = "https://quiz.color-analysis.pro/form/view/226461";

export const product = {
  id: 0,
  trialPrice: 0.99,
  oldPrice: "$59.99",
  safePercent: 54,
  price: 27.99,
  pricePerMonth: "$2.29 / month",
  priceId: process.env.REACT_APP_PRODUCT,
  text: "$0.99",
};

export const baseInputStyle = {
  color: "#325761",
  fontWeight: "400",
  fontFamily: "SF, sans-serif",
  fontSize: "17px",
  fontSmoothing: "antialiased",
  ":-webkit-autofill": {
    color: "#D9D9D9",
    backgroundColor: "transparent",
  },
  "::placeholder": {
    color: "transparent",
    fontFamily: "SF, sans-serif",
    fontWeight: 400,
    fontSize: 17,
    display: "none",
    content: "",
  },
};

export const trialObject = {
  value: "1",
  text: "$1",
  trialValue: 0.99,
  trialValueText: "$0.99",
  willBeText:
    "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
};
